module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGNILu7/TwlmGDVg1IBRA4aLAQB01mQfgM7StQAAAABJRU5ErkJggg=="